import { hot } from "react-hot-loader"
import React, { Component } from "react";

const {
    RadioControl,
    TextControl,
  } = wp.components;
  const {
    RichText,
    InspectorControls,
  } = wp.editor;
  

function EditBlock( { attributes, setAttributes } ) {
    const { defaultURL, tempURL, url, widgetParam, widthField, borderField, scrollField, classField } = attributes;

    function onChangeURLField( newValue ) {
      if(newValue === '')
        setAttributes( { tempURL: defaultURL } );
      else
        setAttributes( { tempURL: '' } );
      setAttributes( { url: newValue } );
    }
    
    function onChangeWidgetParam( newValue ) {
      setAttributes( { widgetParam: newValue } );
    }

    function onChangeWidthField( newValue ) {
      setAttributes( { widthField: newValue } );
    }

    function onChangeBorderField( newValue ) {
      setAttributes( { borderField: newValue } );
    }

    function onChangeScrollField( newValue ) {
      setAttributes( { scrollField: newValue } );
    }

    function onChangeClassField( newValue ) {
      setAttributes( { classField: newValue } );
    }

    return (
      <iframe src={tempURL + url + widgetParam} width={widthField} frameborder={borderField} scrollbars={scrollField} class={classField} id="cloudbeds">
        <InspectorControls>

          <TextControl
            label="URL"
            help=" Enter the URL/Link for your booking engine"
            value={url}
            onChange={ onChangeURLField }
          />

          <RadioControl
            label="Hide Header"
            help="'Yes' shows default booking engine"
            selected={ widgetParam }
            options={
              [
                { label: 'Yes', value: '?widget=1' },
                { label: 'No', value: '' },
              ]
            }
            onChange={ onChangeWidgetParam }
          />

          <TextControl
            label="iFrame Width"
            help="Default is 100%"
            value={ widthField }
            onChange={ onChangeWidthField }
          />

          <TextControl
            label="Frame Border"
            help="Default is 0"
            value={ borderField }
            onChange={ onChangeBorderField }
          />

          <RadioControl
            label="Show Scroll Bars"
            selected={ scrollField }
            options={
              [
                { label: 'Yes', value: 'yes' },
                { label: 'No', value: 'no' },
              ]}
            onChange={ onChangeScrollField }
          />

          <TextControl
            label="CSS Classes for iFrame"
            value={ classField }
            onChange={ onChangeClassField }
          />

        </InspectorControls>
        </iframe>
    );
  }

  export default hot(module)(EditBlock);